import { useEffect, useState } from 'react';
import { fetchCostPerRoomData } from '../services/fetchCostPerRoomData'; 
import { CostPerRoomData } from '../constants/types';

export const useCostPerRoomData = (token: string, year: number) => 
{
  const [initialData, setInitialData] = useState<CostPerRoomData[]>([]);
  const [graphData, setGraphData] = useState<CostPerRoomData[]>([]);
  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchCostPerRoomData(token, year);
            if (formattedData) 
            {
                setInitialData(formattedData);
                setHasConfirmed(true);
            } 
            else 
            {
                setInitialData([]); // important
                setHasConfirmed(false);
            }

        };
        getData();
    }, []);

    useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchCostPerRoomData(token, year);
            if (formattedData) 
            {
                setInitialData(formattedData);
                setHasConfirmed(true);
            } 
            else 
            {
                setInitialData([]); // important
                setHasConfirmed(false);
            }
        };
        getData();
    }, [year]);

    return { initialData, graphData, hasConfirmed, error };
};